// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_20541f2","slideIn":"_0072ff2","hideAnimation":"_50d8cf6","slideOut":"_cceaf96","text":"_367383e","takeSeatButton":"_d0237cf"};